// /src/data/books/Cryptonomics/resumen.js
const CRYPTONOMICS_RESUMEN = {
  id: "cryptonomics-resumen",
  slug: "resumen-del-libro-cryptonomics",
  title: "Cryptonomics — Resumen del Libro",
  language: "es",
  authors: ["Autor no especificado"],
  description:
    "Resumen claro y práctico para lectores con poca formación económica: contexto, funcionamiento e impacto de Bitcoin y las criptomonedas; oportunidades, riesgos y criterios para decidir con criterio antes de invertir.",
  tags: ["bitcoin", "blockchain", "economía", "criptoactivos", "educación financiera"],
  sections: [
    {
      id: "introduccion",
      heading: "Introducción: por qué leer antes de invertir",
      text: `El libro parte de una advertencia esencial: no inviertas en criptomonedas sin comprender qué son, cómo funcionan y qué riesgos implican. El objetivo es alfabetizar al lector en los fundamentos de dinero, inflación, escasez digital y transferencia de valor sin intermediarios, usando un lenguaje accesible y ejemplos cotidianos.`
    },
    {
      id: "origen",
      heading: "Origen de Bitcoin: respuesta a la crisis de confianza",
      text: `Bitcoin nace en 2008–2009 como alternativa a un sistema financiero con emisión monetaria discrecional y alta dependencia de intermediarios. Propone un dinero digital escaso (límite de 21 millones), resistente a censura y verificable públicamente, donde la confianza se traslada del banco a las matemáticas.`,
      list: [
        { title: "Motivación", text: "Proteger poder adquisitivo, reducir dependencia de terceros y habilitar inclusión financiera global." },
        { title: "Propuesta técnica", text: "Registro distribuido (blockchain) + consenso + criptografía = liquidación P2P sin permiso." }
      ]
    },
    {
      id: "como-funciona",
      heading: "Cómo funciona (sin tecnicismos)",
      text: `La blockchain es un libro contable público que agrupa transacciones en bloques enlazados por hash. Mineros/validadores aseguran la red y obtienen recompensas. Las claves privadas controlan la custodia: sin clave, no hay acceso a fondos.`,
      list: [
        { title: "Transacciones", text: "De persona a persona, verificadas por la red, registradas de forma inmutable." },
        { title: "Seguridad", text: "Criptografía de clave pública, pruebas de trabajo/participación y reglas transparentes." },
        { title: "Custodia", text: "Autogestión de llaves (hardware/software) o custodia delegada; cada opción con riesgos distintos." }
      ]
    },
    {
      id: "comparativa",
      heading: "Bitcoin vs dinero tradicional (fiat)",
      table: {
        columns: ["Aspecto", "Fiat", "Bitcoin"],
        rows: [
          ["Emisión", "Flexible/ilimitada (bancos centrales)", "Fija (21M) y predecible"],
          ["Intermediarios", "Bancos, procesadores de pago", "Red P2P sin permisos"],
          ["Liquidación", "Horaria/lenta, reversible", "Casi inmediata, final e irreversible"],
          ["Inflación", "Riesgo de pérdida de poder adquisitivo", "Escasez programada"],
          ["Transparencia", "Baja para el público", "Libro contable público"],
          ["Propiedad", "Depósito en cuentas de terceros", "Custodia directa mediante claves"]
        ]
      }
    },
    {
      id: "impacto",
      heading: "Impacto social y económico",
      text: `Cripto abre nuevas vías de inclusión y organización económica: ahorro en contextos inflacionarios, remesas rápidas, micropagos y propiedad digital de activos.`,
      list: [
        { title: "Inclusión financiera", text: "Acceso global con solo un móvil e Internet." },
        { title: "Remesas y pagos", text: "Costos menores y liquidez 24/7." },
        { title: "Propiedad digital", text: "Activos, identidad y reputación verificables on-chain." }
      ]
    },
    {
      id: "riesgos",
      heading: "Riesgos y malentendidos comunes",
      text: `La tecnología resuelve problemas, pero no elimina los riesgos. La falta de educación y custodia insegura son causas frecuentes de pérdidas.`,
      list: [
        { title: "Volatilidad", text: "Movimientos bruscos de precio; no apto para perfiles conservadores sin horizonte largo." },
        { title: "Custodia y llaves", text: "Perder la semilla equivale a perder el dinero; cuidado con phishing y malware." },
        { title: "Estafas", text: "Promesas de rentabilidad garantizada, esquemas piramidales, tokens falsos." },
        { title: "Regulación e impuestos", text: "Obligaciones fiscales y normas KYC/AML varían por país." }
      ]
    },
    {
      id: "casos-uso",
      heading: "Casos de uso prácticos",
      list: [
        { title: "Reserva de valor", text: "Estrategia de ahorro en contextos de devaluación, con horizonte de largo plazo." },
        { title: "Pagos internacionales", text: "Transferencias transfronterizas rápidas con liquidez global." },
        { title: "Micropagos y economía digital", text: "Modelos de negocio de bajo ticket en contenido/servicios." }
      ]
    },
    {
      id: "metodologia",
      heading: "Metodología para el lector principiante",
      text: `Aprender antes que invertir. Empezar pequeño, diversificar, documentar operaciones y definir un plan.`,
      list: [
        { title: "Educación primero", text: "Entender claves, wallets, fees, riesgos y buenas prácticas." },
        { title: "Práctica controlada", text: "Transacciones de bajo monto para familiarizarse." },
        { title: "Seguridad", text: "Uso de hardware wallet y copias de seguridad de la semilla." },
        { title: "Registro y fiscalidad", text: "Llevar control de operaciones y obligaciones legales." }
      ]
    },
    {
      id: "conclusiones",
      heading: "Conclusiones del libro",
      text: `Bitcoin no promete riqueza rápida: ofrece soberanía financiera y un marco de confianza programable. Su aporte clave es cultural: trasladar la confianza de instituciones a reglas abiertas verificables. La decisión de invertir debe basarse en conocimiento, tolerancia al riesgo y horizonte temporal.`
    },
    {
      id: "takeaways",
      heading: "Puntos clave (Takeaways)",
      list: [
        { title: "Escasez creíble", text: "Oferta limitada y reglas transparentes." },
        { title: "Propiedad directa", text: "Tus llaves = tus fondos." },
        { title: "Transparencia", text: "Contabilidad pública e inmutable." },
        { title: "Riesgo real", text: "Volatilidad, custodia y estafas exigen disciplina y formación." }
      ]
    }
  ],
  // Opcional: recursos para tu visor si quieres mostrar enlaces internos/externos
  resources: [
    { type: "glossary", url: "/data/books/Cryptonomics/glosario" },
    { type: "chapter", url: "/data/books/Cryptonomics/cap1" }
  ]
};

export default CRYPTONOMICS_RESUMEN;
